import React from "react";

const experienceContent = [
  {
    year: "   2023",
    position: " CEO & Fundador",
    compnayName: "Agiliza IO",
    details: `  
            • Administrar Agiliza IO - Plataforma de validação de comprovativos Bancários
            
           
    `,
  },
  {
    year: "   2021",
    position: " IT SENIOR | Team Leader",
    compnayName: "Academia BAI",
    details: `  
            • Administrar Infra-estrutura Tecnológica
            • Monitorar o desempenho de sistemas, diagnósticos e resolução de problemas
            • Garantir a segurança da infra-estrutura de T.I
            • Desenvolver Aplicações Desktop e Web
    `,
  },
  {
    year: "2018",
    position: " Analista de Sistemas",
    compnayName: "Velonet LDA",
    details: ` Implementação de sistemas de virtualização ( VMware - ESXi e Hyper - V )
                Reestruturação dos servidores de arquivos e suas políticas de acesso
                Auditoria Rede / Servidor
              
    
    `,
  },
  {
    year: "2017",
    position: "Técnico de IT",
    companyName: "Banco Millennium Atlântico| CHK | Nexfone",
    details: `A fusão entre os Bancos (Millennium e Atlântico) ouve a necessidade deste projecto a nível nacional
    O Projecto teve como finalidade a migração do Domínio | Storage | E-mail`,
  },
];

const Experience = () => {
  return (
    <ul>
      {experienceContent.map((val, i) => (
        <li key={i}>
          <div className="icon">
            <i className="fa fa-briefcase"></i>
          </div>
          <span className="time open-sans-font text-uppercase">{val.year}</span>
          <h5 className="poppins-font text-uppercase">
            {val.position}
            <span className="place open-sans-font">{val.compnayName}</span>
          </h5>
          <p className="open-sans-font">{val.details}</p>
        </li>
      ))}
    </ul>
  );
};

export default Experience;
